var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import useSessionReplayCore from "../../hooks/useSessionReplayCore";
import DebugIndicator from "./components/debug-indicator";
import DebugAuthorisationMessage from "./components/debug-authorisation-message";
import { sendLarkMessageToGroup } from "./components/debug-indicator/service";
import { getDebugModeUrlParams } from "../../utils/session-replay-debug-mode-portal";
import useExperiments from "../../hooks/useExperiments";
var RecordingStatus = /* @__PURE__ */ ((RecordingStatus2) => {
  RecordingStatus2["INIT"] = "INIT";
  RecordingStatus2["GETTING_AUTHORISATION"] = "GETTING_AUTHORISATION";
  RecordingStatus2["RECORDING"] = "RECORDING";
  RecordingStatus2["STOPPED_RECORDING"] = "STOPPED_RECORDING";
  RecordingStatus2["NO_AUTHORISATION"] = "NO_AUTHORISATION";
  return RecordingStatus2;
})(RecordingStatus || {});
const SessionReplayDebugMode = (props) => {
  const { customIndicatorComponent, customAuthorisationComponent } = props;
  const { stopRecording, recordingMetaInfo } = useSessionReplayCore();
  const { internalExperiments, setInternalExperiments } = useExperiments();
  const larkGroupId = internalExperiments.larkGroupId;
  const debugModeUrlParams = useMemo(() => getDebugModeUrlParams(), []);
  useEffect(() => {
    return () => {
      var _a;
      if ((recordingMetaInfo == null ? void 0 : recordingMetaInfo.id) && larkGroupId) {
        stopRecording();
        sendLarkMessageToGroup({
          link: (_a = recordingMetaInfo == null ? void 0 : recordingMetaInfo.id) != null ? _a : "",
          groupId: larkGroupId != null ? larkGroupId : ""
        });
      }
    };
  }, [recordingMetaInfo, larkGroupId]);
  useEffect(() => {
    if (recordingStatus === "INIT" /* INIT */) {
      if ((debugModeUrlParams == null ? void 0 : debugModeUrlParams.enableDebug) && (debugModeUrlParams == null ? void 0 : debugModeUrlParams.alreadyRecording)) {
        setRecordingStatus("RECORDING" /* RECORDING */);
        setInternalExperiments(__spreadProps(__spreadValues({}, internalExperiments), { larkGroupId: debugModeUrlParams == null ? void 0 : debugModeUrlParams.larkGroupId }));
      } else if ((debugModeUrlParams == null ? void 0 : debugModeUrlParams.enableDebug) && !(debugModeUrlParams == null ? void 0 : debugModeUrlParams.alreadyRecording)) {
        setRecordingStatus("GETTING_AUTHORISATION" /* GETTING_AUTHORISATION */);
        setInternalExperiments(__spreadProps(__spreadValues({}, internalExperiments), { larkGroupId: debugModeUrlParams == null ? void 0 : debugModeUrlParams.larkGroupId }));
      }
    }
  }, [debugModeUrlParams]);
  const [recordingStatus, setRecordingStatus] = useState("INIT" /* INIT */);
  if (recordingStatus === "GETTING_AUTHORISATION" /* GETTING_AUTHORISATION */) {
    return /* @__PURE__ */ jsx(
      DebugAuthorisationMessage,
      {
        recordingStatus,
        setRecordingStatus,
        customAuthorisationComponent
      }
    );
  }
  if (recordingStatus === "RECORDING" /* RECORDING */) {
    return /* @__PURE__ */ jsx(
      DebugIndicator,
      {
        recordingStatus,
        setRecordingStatus,
        customIndicatorComponent
      }
    );
  }
  if (recordingStatus === "INIT" /* INIT */ || recordingStatus === "NO_AUTHORISATION" /* NO_AUTHORISATION */ || recordingStatus === "STOPPED_RECORDING" /* STOPPED_RECORDING */) {
    return null;
  }
  return null;
};
var session_replay_debug_mode_portal_default = SessionReplayDebugMode;
export {
  RecordingStatus,
  session_replay_debug_mode_portal_default as default
};
